<div class="card" style="width:100%; height:100%; display: flex;  justify-content: center; align-items: center; ">
    <nz-card >
        <h1>Thank You For Choosing Us!</h1>
        <h5>Our Representitive Will Contact You Shortly!!!</h5>
    </nz-card>
</div>
